n<template>

  <div class="d-flex">
    <bill-to :pro="statement.pro" />

    <v-spacer />

    <div class="d-flex flex-column">
      <div class="d-flex">
        <div class="black--text font-weight-bold mr-auto">Statement:</div>
        <div class="ml-2">{{ statement.invoice_id }}</div>
      </div>
      <div class="d-flex">
        <div class="black--text font-weight-bold mr-auto">Date:</div>
        <div class="ml-2">{{ formatDate(statement.invoice_date) }}</div>
      </div>
    </div>
  </div>

</template>

<script>
import formatters from '@/lib/formatters'
import BillTo from './BillTo'

export default {
  name: 'StatementHeader',

  props: {
    statement: {
      type: Object,
      required: true,
    },
  },

  components: { BillTo },

  methods: {
    ...formatters,
  }
}
</script>